import { render, staticRenderFns } from "./ispIncomeDetail.vue?vue&type=template&id=458f9b90&scoped=true&"
import script from "./ispIncomeDetail.vue?vue&type=script&lang=js&"
export * from "./ispIncomeDetail.vue?vue&type=script&lang=js&"
import style0 from "./ispIncomeDetail.vue?vue&type=style&index=0&id=458f9b90&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458f9b90",
  null
  
)

export default component.exports